import {
  Box,
  Button,
  IconButton,
  Input,
  Menu,
  MenuItem,
  Modal,
  Switch,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import * as Yup from "yup";
import { GridColDef } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import SearchBar from "components/SearchBar";
import TableComponent from "components/TableComponent";
import { showError, showToast } from "../../helpers/showToast";
import MainContainer from "layout/MainContainer";
import { ConfirmationModal } from "Modals/confirmationModal";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useAddBrandMutation,
  useAddCategoryMutation,
  useAddClassMutation,
  useLazyBrandStatusQuery,
  useLazyCategoryStatusQuery,
  useLazyClassStatusQuery,
  useLazyDeleteBrandQuery,
  useLazyDeleteCategoryQuery,
  useLazyDeleteClassQuery,
  useLazyGetAllBrandsQuery,
  useLazyGetAllCategoryQuery,
  useLazyGetAllClassesQuery,
  useUpdateBrandMutation,
  useUpdateCategoryMutation,
  useUpdateClassMutation,
} from "service/category";
import { Category, CommonBody, Listing } from "types/General";
import { isValidInput } from "utils/validations";
import { useFormik } from "formik";
import { generateEncryptedKeyBody } from "utils/crypto";
import { UploadMedia } from "utils/mediaUpload";
import { UPDATE_TYPES } from "utils/enums";
import CustomPagination from "components/Panigation";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Categories = () => {
  const navigate = useNavigate();
  const [getCategories] = useLazyGetAllCategoryQuery();
  const [deleteCategory] = useLazyDeleteCategoryQuery();
  const [addCategory] = useAddCategoryMutation();
  const [updateCategory] = useUpdateCategoryMutation();
  const [changeCategoryStatus] = useLazyCategoryStatusQuery();
  const [getBrands] = useLazyGetAllBrandsQuery();
  const [deleteBrand] = useLazyDeleteBrandQuery();
  const [changeBrandStatus] = useLazyBrandStatusQuery();
  const [updateBrand] = useUpdateBrandMutation();
  const [addBrand] = useAddBrandMutation();
  const [getClasses] = useLazyGetAllClassesQuery();
  const [changeClassStatus] = useLazyClassStatusQuery();
  const [addClass] = useAddClassMutation();
  const [updateClass] = useUpdateClassMutation();
  const [deleteClass] = useLazyDeleteClassQuery();

  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState<Category[]>([]);
  const [brands, setBrands] = useState<any>([]);
  const [classes, setClasses] = useState<any>([]);
  const [count, setCount] = useState(10);
  const [loading, setLoading] = useState(false);
  const [valueTabs, setValueTabs] = React.useState(0);
  const [page, setPage] = useState<number>(1);
  const [open, setOpen] = useState(false);
  const [openAddCategory, setOpenAddCategory] = useState(false);
  const [modalType, setModalType] = useState("");
  const [categoryImage, setCategoryImage] = useState("");
  const [edit, setEdit] = useState(false);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
    setPage(1);
    setSearchTerm("");
  };

  const handleProfileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setCategoryImage("");
      return;
    }

    const imageUrl = (await UploadMedia(file)) as any;
    if (imageUrl?.data?.image) {
      setCategoryImage(imageUrl?.data?.image || "");
    }
  };

  const columns: GridColDef[] = [
    {
      flex: 1,
      minWidth: 100,
      field: "image",
      headerName: "Category Image",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure
              style={{ cursor: "pointer", backgroundColor: "#D3D3D3" }}
              onClick={() => {}}
            >
              <img
                style={{ objectFit: "contain" }}
                src={
                  valueTabs === 0
                    ? row?.icon
                    : valueTabs === 1
                      ? row?.logo
                      : valueTabs === 2
                        ? row?.logo
                        : "/static/images/picture.png"
                }
                alt="Vehicle"
              />
            </figure>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 100,
      field: "name",
      headerName: "Category Name",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.name?.en}</p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 150,
      field: "status",
      filterable: false,
      sortable: false,
      headerName: "Block/Unblock",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.isActive}
            onChange={() => {
              if (valueTabs === 0) {
                handleCategoryStatus(row?._id);
              } else if (valueTabs === 1) {
                handleBrandStatus(row?._id);
              } else {
                handleClassStatus(row?._id);
              }
            }}
          />
        );
      },
    },

    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="table_actions v2">
          <Box>
            <IconButton
              onClick={() => {
                setEdit(true);
                setSelectedCategory(row?._id);
                setOpenAddCategory(true);
                formik.setFieldValue("name", row?.name?.en);
                setCategoryImage(valueTabs === 0 ? row?.icon : row?.logo);
              }}
            >
              <img src="/static/images/edit2_icon.svg" alt="" />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              onClick={() => {
                setModalType("delete");
                setSelectedCategory(row?._id);
                setOpen(true);
              }}
            >
              <img src="/static/images/trash2_icon.svg" alt="" />
            </IconButton>
          </Box>
        </div>
      ),
    },
  ];

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: "",
    },

    validationSchema: Yup.object({
      name: Yup.string()
        .required("This field is required")
        .min(2, "Minimum 2 characters are required"),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);

      if (!categoryImage) {
        showError("Please upload image");
        return;
      }

      const body = {
        ...(valueTabs === 0
          ? { icon: categoryImage }
          : { logo: categoryImage }),
        name: {
          en: values?.name || "",
        },
      };

      console.log(body);

      try {
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

        if (valueTabs === 0) {
          // Category Flow
          if (edit) {
            const response = await updateCategory({
              body: encryptedBody,
              id: selectedCategory,
            }).unwrap();

            if (response?.statusCode === 200) {
              showToast("Category updated successfully");
              setOpenAddCategory(false);
              getCategoriesApi();
            }
          } else {
            const response = await addCategory({
              body: encryptedBody,
            }).unwrap();

            if (response?.statusCode === 200) {
              showToast("Category added successfully");
              setOpenAddCategory(false);
              getCategoriesApi();
            }
          }
        } else if (valueTabs === 1) {
          // Brand Flow
          if (edit) {
            const response = await updateBrand({
              body: encryptedBody,
              id: selectedCategory,
            }).unwrap();

            if (response?.statusCode === 200) {
              showToast("Brand updated successfully");
              setOpenAddCategory(false);
              getBrandApi();
            }
          } else {
            const response = await addBrand({
              body: encryptedBody,
            }).unwrap();

            if (response?.statusCode === 200) {
              showToast("Brand added successfully");
              setOpenAddCategory(false);
              getBrandApi();
            }
          }
        } else if (valueTabs === 2) {
          // Brand Flow
          if (edit) {
            const response = await updateClass({
              body: encryptedBody,
              id: selectedCategory,
            }).unwrap();

            if (response?.statusCode === 200) {
              showToast("Class updated successfully");
              setOpenAddCategory(false);
              getClassApi();
            }
          } else {
            const response = await addClass({
              body: encryptedBody,
            }).unwrap();

            if (response?.statusCode === 200) {
              showToast("Class added successfully");
              setOpenAddCategory(false);
              getClassApi();
            }
          }
        }
      } catch (error: any) {
        showError(error?.data?.message || "");
        console.error(error);
      }
    },
  });

  const getCategoriesApi = async () => {
    setLoading(true);
    try {
      const response = await getCategories({
        page: page,
        search: debouncedSearchTerm,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setCategories(response?.data?.list);
        setCount(response?.data?.totalCount);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getBrandApi = async () => {
    setLoading(true);
    try {
      const response = await getBrands({
        page: page,
        search: debouncedSearchTerm,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setBrands(response?.data?.brands);
        setCount(response?.data?.totalCount);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getClassApi = async () => {
    setLoading(true);
    try {
      const response = await getClasses({
        page: page,
        search: debouncedSearchTerm,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setClasses(response?.data?.Classs);
        setCount(response?.data?.totalCount);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const handleCategoryStatus = async (id: string) => {
    try {
      const response = await changeCategoryStatus({
        id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        showToast(response?.message || "");
        getCategoriesApi();
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      console.error(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const handleBrandStatus = async (id: string) => {
    try {
      const response = await changeBrandStatus({
        id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        showToast(response?.message || "");
        getBrandApi();
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      console.error(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const handleClassStatus = async (id: string) => {
    try {
      const response = await changeClassStatus({
        id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        showToast(response?.message || "");
        getClassApi();
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      console.error(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const deleteCategoryApi = async (id: string) => {
    setLoading(true);
    try {
      const response = await deleteCategory({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        getCategoriesApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const deleteBrandApi = async (id: string) => {
    setLoading(true);
    try {
      const response = await deleteBrand({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        getBrandApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const deleteClassApi = async (id: string) => {
    setLoading(true);
    try {
      const response = await deleteClass({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        getClassApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (valueTabs === 0) {
      getCategoriesApi();
    } else if (valueTabs === 1) {
      getBrandApi();
    } else {
      getClassApi();
    }
  }, [valueTabs, debouncedSearchTerm, page]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Car/Brand Categories</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Car/Brand Categories
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button
                  className="btn btn_orange"
                  onClick={() => {
                    setOpenAddCategory(true);
                    formik.resetForm();
                    setCategoryImage("");
                    setEdit(false);
                  }}
                >
                  {valueTabs === 0
                    ? "Add Category"
                    : valueTabs === 1
                      ? "Add Brand"
                      : "Add Class"}
                </Button>
              </Box>
            </div>
          </div>

          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Car Categories" {...a11yProps(0)} />
            <Tab label="Brand Categories" {...a11yProps(1)} />
            <Tab label="Car Classes" {...a11yProps(2)} />
          </Tabs>

          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={
                valueTabs === 0
                  ? categories
                  : valueTabs === 1
                    ? brands
                    : classes
              }
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
            {valueTabs === 0 && categories?.length ? (
              <CustomPagination
                currentPage={page - 1}
                totalPages={Math.ceil(count / 10)}
                count={count}
                pageSize={10}
                onPageChange={(page) => setPage(page + 1)}
              />
            ) : null}
            {valueTabs === 1 && brands?.length ? (
              <CustomPagination
                currentPage={page - 1}
                totalPages={Math.ceil(count / 10)}
                count={count}
                pageSize={10}
                onPageChange={(page) => setPage(page + 1)}
              />
            ) : null}
            {valueTabs === 2 && classes?.length ? (
              <CustomPagination
                currentPage={page - 1}
                totalPages={Math.ceil(count / 10)}
                count={count}
                pageSize={10}
                onPageChange={(page) => setPage(page + 1)}
              />
            ) : null}
          </div>
        </Box>
      </div>

      <Modal
        className="modal addNotification_modal"
        id="addNotificationModal"
        aria-labelledby="addNotification-modal-title"
        aria-describedby="addNotification-modal-description"
        open={openAddCategory}
        onClose={() => setOpenAddCategory(false)}
      >
        <div className="modal-dialog">
          <div className="modal-body">
            <div
              className="btn-close"
              onClick={() => setOpenAddCategory(false)}
            >
              <CloseIcon />
            </div>
            <div className="modal_title">
              <h2>
                {valueTabs === 0
                  ? `${edit ? "Edit" : "Add"} Category`
                  : valueTabs === 1
                    ? `${edit ? "Edit" : "Add"} Brand`
                    : `${edit ? "Edit" : "Add"} Class`}
              </h2>
            </div>
            <form className="form" onSubmit={formik.handleSubmit}>
              <div className="gap_p">
                <div className="control_group w_50">
                  <label>Image</label>
                  <div className="upload_box">
                    <label>
                      {/* {categoryImage && (
                        <IconButton
                          className="crossIcon"
                          onClick={() => setCategoryImage("")}
                        >
                          <CloseIcon />
                        </IconButton>
                      )} */}
                      <figure>
                        <img
                          src={
                            categoryImage
                              ? categoryImage
                              : "/static/images/user_placeholder.png"
                          }
                          alt="Upload"
                        />
                      </figure>
                      <IconButton className="uploadIcon">
                        <label htmlFor="icon-button-file">
                          <Button component="span" className="upload_image_btn">
                            <img
                              src="/static/images/edit2_icon.svg"
                              alt="Upload"
                            />
                            <Input
                              sx={{ display: "none" }}
                              id="icon-button-file"
                              type="file"
                              inputProps={{
                                accept: "image/png,image/jpeg",
                              }}
                              onChange={(e: any) => {
                                handleProfileUpload(e);
                                e.target.value = null;
                              }}
                            />
                          </Button>
                        </label>
                      </IconButton>
                    </label>
                  </div>
                </div>

                <div className="control_group w_50" />
                <div className="control_group w_50">
                  <label>Name</label>
                  <TextField
                    variant="outlined"
                    placeholder="Enter the name"
                    className="text_field"
                    fullWidth
                    hiddenLabel
                    name="name"
                    id="name"
                    inputProps={{ maxLength: 40 }}
                    value={formik.values.name}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </div>
              </div>

              <div className="form_btn center">
                <Button
                  className="btn btn_secondary"
                  onClick={() => navigate("/categories")}
                  type="submit"
                >
                  {edit ? "Update" : "Submit"}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <ConfirmationModal
        text={
          modalType === "delete"
            ? "Are you sure to delete this Category?"
            : modalType === "accept"
              ? "Are you sure to approve this individual?"
              : modalType === "reject"
                ? "Are you sure to reject this individual?"
                : ""
        }
        openModal={open}
        setOpenModal={setOpen}
        handleSubmit={() => {
          if (valueTabs === 0) {
            deleteCategoryApi(selectedCategory);
          } else if (valueTabs === 1) {
            deleteBrandApi(selectedCategory);
          } else {
            deleteClassApi(selectedCategory);
          }

          setOpen(false);
        }}
      />
    </MainContainer>
  );
};

export default Categories;
